import { assign } from 'lodash';
// import { Logger } from 'vue-infra';
import { DATA_STATES } from '@/store/consts';
import ShellService from '@/services/shell/ShellService';
import { actions as baseActions, ACTION_TYPES as BASE_ACTION_TYPES } from '../base-collection/actions';
import { MUTATION_TYPES } from './mutations';

// const logger = Logger.getLogger('workato-configuration');

const ACTION_TYPES = assign({}, BASE_ACTION_TYPES, {
  FETCH_PARTNERS: 'fetchPartners',
});

const actions = assign({}, baseActions, {
  [ACTION_TYPES.FETCH_PARTNERS]: async ({ commit }) => {
    commit(MUTATION_TYPES.SET_DATA_STATE, DATA_STATES.LOADING);
    try {
      const { partners } = await ShellService.getShellPartners();
      commit(MUTATION_TYPES.SET_ITEMS, partners);
      commit(MUTATION_TYPES.SET_DATA_STATE, DATA_STATES.SUCCESS);
    } catch (err) {
      commit(MUTATION_TYPES.SET_DATA_STATE, DATA_STATES.ERROR);
    }
  },
});

export {
  actions,
  ACTION_TYPES,
};
